import React from 'react'
import PageForm from 'components/pageForm/PageForm.js'
import ListBodyVivier from './components/content/body.list.vivier.js'


function ListAllVivier() {
  return (
    <>
    <PageForm>
        <ListBodyVivier/>
    </PageForm>
</>
  )
}

export default ListAllVivier